import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { migrateCache } from './utils/cache';
import { GlobalErrorBoundary } from './components/GlobalErrorBoundary';

// 🔥 PROTECTION RADICALE: Charger la protection DOM AVANT TOUT
import './utils/domProtection';

// Migrer le cache au démarrage (v1 → v2)
migrateCache();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

// 🔥 PROTECTION TOTALE: ErrorBoundary global + pas de StrictMode (qui peut causer des doubles renders)
try {
  root.render(
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  );
} catch (error) {
  console.error('🔥 [index.js] Erreur lors du render initial:', error);
  // Même en cas d'erreur, afficher quelque chose
  rootElement.innerHTML = `
    <div style="padding: 24px; color: #fff; background: #1a1a1a; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <div style="font-size: 18px; margin-bottom: 12px;">Erreur de chargement</div>
      <button onclick="window.location.reload()" style="padding: 12px 24px; background: #5fa8ff; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 16px;">
        Recharger la page
      </button>
    </div>
  `;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
